import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

export default function SetPassword({ onDone }) {
  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');
  const [skipped, setSkipped]     = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true); setError('');
    const { error } = await supabase.auth.updateUser({ password });
    if (error) setError(error.message);
    else onDone();
    setLoading(false);
  };

  if (skipped) { onDone(); return null; }

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.icon}>🔑</div>
        <h2 style={s.title}>Set a password</h2>
        <p style={s.sub}>
          You're in! Set a password so you can sign in quickly next time —
          no need to wait for a magic link email.
        </p>
        <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
          <label style={s.label}>New password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="At least 8 characters" required minLength={8} style={s.input} autoFocus />
          <label style={{ ...s.label, marginTop: 8 }}>Confirm password</label>
          <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
            placeholder="Repeat your password" required style={s.input} />
          {error && <p style={s.error}>{error}</p>}
          <button type="submit" disabled={loading} style={s.primaryBtn}>
            {loading ? 'Saving…' : 'Set password & continue'}
          </button>
        </form>
        <button style={s.skipBtn} onClick={() => setSkipped(true)}>
          Skip for now — I'll use magic links
        </button>
      </div>
    </div>
  );
}

const s = {
  wrap: { minHeight: '100vh', background: 'linear-gradient(135deg, #2D5016 0%, #3E6B1F 60%, #7BA05B 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: "'Nunito', sans-serif" },
  card: { background: '#fff', borderRadius: 20, padding: '40px 36px', maxWidth: 420, width: '100%', textAlign: 'center', boxShadow: '0 8px 40px rgba(0,0,0,0.18)' },
  icon: { fontSize: '2.5rem', marginBottom: 12 },
  title: { fontFamily: "'Playfair Display', serif", fontSize: '1.6rem', fontWeight: 700, color: '#2D5016', marginBottom: 8 },
  sub: { color: '#6B7F5A', fontSize: '0.9rem', lineHeight: 1.5, marginBottom: 24 },
  label: { display: 'block', fontWeight: 700, fontSize: '0.88rem', color: '#2D5016', marginBottom: 6 },
  input: { width: '100%', padding: '11px 14px', border: '2px solid #C8D9B0', borderRadius: 8, fontFamily: "'Nunito', sans-serif", fontSize: '1rem', color: '#1C2B0E', outline: 'none', boxSizing: 'border-box', marginBottom: 8 },
  error: { color: '#C0392B', fontSize: '0.85rem', marginBottom: 8 },
  primaryBtn: { width: '100%', padding: '13px', background: '#2D5016', color: '#fff', border: 'none', borderRadius: 10, fontFamily: "'Nunito', sans-serif", fontSize: '1rem', fontWeight: 700, cursor: 'pointer', marginTop: 4, marginBottom: 12 },
  skipBtn: { background: 'none', border: 'none', color: '#6B7F5A', cursor: 'pointer', fontSize: '0.85rem', textDecoration: 'underline', fontFamily: "'Nunito', sans-serif" },
};
